import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";


export const GET_FEE_SCHEDULE_DATA_LISTS = "GET_FEE_SCHEDULE_DATA_LISTS";

export const service = async () => {
    const options: object = {
        url: `/Api/PayerGroup/GetFeeScheduleDataLists`,
        method: 'GET',  
    }; 

    const response = callMvcApi(options);
    return response;
};

const mockData = () => {
    return [];
};

const mock = () => {
    const promise = new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(mockData());
        }, 2000);
    });
    return promise;
};

register(GET_FEE_SCHEDULE_DATA_LISTS, service, mock);